import { api } from '../utils/apiClient';

export const segmentService = {
  async getAll() {
    return api.get('/segments');
  },

  async getById(id) {
    return api.get('/segments/' + id);
  },

  async create(segment) {
    return api.post('/segments', segment);
  },

  async update(id, segment) {
    return api.put('/segments/' + id, segment);
  },

  async remove(id) {
    return api.del('/segments/' + id);
  },

  // conditions/matchType already in backend condition JSON shape — see
  // utils/segmentConditions.js for the UI-filter -> condition translation.
  async previewConditions(conditions, matchType) {
    return api.post('/segments/preview', { conditions, match_type: matchType || 'ALL' });
  },

  async previewSaved(id) {
    return api.post('/segments/' + id + '/preview');
  },

  // { name, sample_values }[] discovered live from ClickHouse — no stored
  // catalog, since any event can carry any property. entityType is the
  // earning condition's alternate filter key (see FilterRow.jsx's earning
  // block) — earning_events has no meaningful event_name to key off.
  async getEventProperties(table, eventName, entityType) {
    return api.get('/segments/event-properties', { table, event_name: eventName, entity_type: entityType });
  },

  // Live event names/tables + real profile-field and entity-status values
  // discovered from ClickHouse — replaces the old hardcoded dropdown data.
  async getOptions() {
    return api.get('/segments/options');
  },
};
